import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { modalState } from '../../Recoil/Atoms';

import styles from './modal.module.scss';

const Modal = ({ message, success }) => {
    const [, setModalState] = useRecoilState(modalState); // Get state setter

    useEffect(() => {
        // Close the modal automatically after 3 seconds
        const timer = setTimeout(() => {
            setModalState({ isOpen: false, message: '' });
        }, 3000);

        // Cleanup function to clear timeout if modal unmounts early
        return () => clearTimeout(timer);
    }, [setModalState]);

    return (
        <div className={`${styles.container} ${success ? styles.success : styles.error}`}>
            <h3>{message}</h3>
        </div>
    );
};

export default Modal;
